// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 419 ? "81a489ea" : chunkId) + "." + {"268":"f6e26c48acf5f122","419":"87eae0e21d3d6e25","647":"a227679451209538"}[chunkId] + ".js";
};